import React from 'react'
import { Upload as UploadAnt, Icon } from 'antd'

import { UploadProps } from 'antd/lib/upload'
import { useT } from 'src/core/hooks/use-translation'

function Upload({ children, ...props }: UploadProps & { children?: any }) {
  const { t } = useT()
  return (
    <UploadAnt
      {...props}
      locale={{
        previewFile: t('web.receipt.form.images.preview-file'),
        removeFile: t('web.receipt.form.images.remove-file'),
        uploadError: t('web.receipt.form.images.upload-error'),
        uploading: t('web.receipt.form.images.uploading')
      }}
    >
      {children}
    </UploadAnt>
  )
}

function AddImage() {
  const { t } = useT()
  return (
    <div data-test-id="receipt-upload-add">
      <Icon type="plus" />
      <div className="ant-upload-text">
        {t('web.receipt.form.images.upload')}
      </div>
    </div>
  )
}

export default Upload
export { AddImage }
